import React from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { useIntl } from 'react-intl';
import { ALERT_TYPE_FILTER_LABEL_IDS, ALERT_TYPE_FILTER_OPTIONS } from './alertsFilterUtils';

export default function AlertsFilters({ alertTypeFilter, onAlertTypeFilterChange }) {
    const intl = useIntl();

    const typeTitle = intl.formatMessage({
        id: 'monitoring.alerts.filter.title',
    });
    const typeLabel = intl.formatMessage({
        id: 'monitoring.alerts.filter.label',
    });

    return (
        <FormControl size="small" sx={{ minWidth: 180, flexShrink: 0 }}>
            <InputLabel shrink id="alerts-type-filter-label">
                {typeTitle}
            </InputLabel>
            <Select
                labelId="alerts-type-filter-label"
                data-testid="alerts-type-filter"
                value={alertTypeFilter}
                label={typeTitle}
                aria-label={typeLabel}
                onChange={(event) => onAlertTypeFilterChange(event.target.value)}
            >
                {ALERT_TYPE_FILTER_OPTIONS.map((option) => (
                    <MenuItem key={option} value={option}>
                        {intl.formatMessage({ id: ALERT_TYPE_FILTER_LABEL_IDS[option] })}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}
